import { get } from "../../utils/objectHelpers";

$ {
    const card = get(input, "card", {});
    const url = get(card, "action.URL", null);
    const title = get(card, "title", {});
    const subTitle = get(card, "subTitle", null);
    const buttonTextSpans = get(card, "slug.textSpans", null);
    const legalTextSpans = get(card, "button.textSpans", null);
    const legalSource = get(card, "button.action.URL", null);
    const image = get(card, "image", {});
}

<section class="str-marketing-banner app-layout--negate-gutters-small">
    <div class="str-marketing-banner__text">
        <h2 class="str-marketing-banner__text--title"><str-textual-display ...title /></h2>
        <if(subTitle)>
            <h4 class="str-marketing-banner__text--sub-title"><str-textual-display ...subTitle /></h4>
        </if>
        <div class="str-marketing-banner__text--button">
            <ebay-button priority="primary" size="large" href=url>
                <str-textual-display textSpans=buttonTextSpans />
            </ebay-button>
        </div>
        <if(legalTextSpans && legalSource)>
            <str-legal-lightbox linkTextSpans=legalTextSpans source=legalSource />
        </if>
    </div>
    <str-image-square href=url class="str-marketing-banner__image" ...image />
</section>
